import React from 'react';
import PropTypes from 'prop-types';
import { reduceToUniqueProducts } from 'helpers/packHelpers';
import styled from 'styled-components';
import ProductImage from './ProductImage';

const Wrapper = styled.div`
  margin: ${({ theme }) => theme.spacing * 2}px 0;
  .ProductImage:not(:last-of-type) {
    margin-bottom: ${({ theme }) => theme.spacing * 2}px;
    padding-bottom: ${({ theme }) => theme.spacing * 2}px;
    border-bottom: 1px solid ${({ theme }) => theme.palette.grey[4]};
  }
`;

const ProductImageView = ({ className, items, format }) => {
  const classes = ['ProductImageView'];
  if (className) classes.push(className);

  const uniqueProducts = reduceToUniqueProducts(items);
  const sameLenses = uniqueProducts && uniqueProducts.filter((p) => p.kind === 'lens').length === 1;
  const withSolution = uniqueProducts && uniqueProducts.filter((p) => p.kind === 'solution').length > 0;

  return (
    <Wrapper className={classes.join(' ')}>
      {uniqueProducts
          && uniqueProducts.map((p) => {
            const chip = (sameLenses && withSolution && p.kind === 'lens' && 'lens')
            || (!sameLenses && p.kind === 'lens' && p.lensId)
            || (p.kind === 'solution' && 'solution')
            || undefined;

            return (
              <ProductImage
                key={p.lensId || p.productId}
                item={p}
                format={format}
                chip={chip}
              />
            );
          })}
    </Wrapper>
  );
};

ProductImageView.displayName = 'ProductImageView';

ProductImageView.propTypes = {
  className: PropTypes.string,
  format: PropTypes.oneOf(['largeImage', 'thumbnailAndText']),
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

ProductImageView.defaultProps = {
  className: null,
  format: 'largeImage',
};

export default ProductImageView;
